import FileDownload from "@mui/icons-material/FileDownload";
import { Button, IconButton, Tooltip } from "@mui/material";

import { useChemicalInventoryExport } from "./ChemicalInventoryExportProvider";

export function getInventoryExportDisabledState({
  loading,
  count,
}: {
  loading: boolean;
  count: number;
}): { disabled: boolean; disabledReason?: string } {
  if (loading) {
    return { disabled: true };
  }
  if (count === 0) {
    return { disabled: true, disabledReason: "No facilities to export" };
  }
  return { disabled: false };
}

export function ChemicalInventoryExportButton({
  facilityId,
  facilityName,
  filter,
  iconOnly = false,
  title = "Export",
  disabled: disabledProp = false,
  disabledReason,
}: {
  facilityId?: string;
  facilityName?: string;
  filter?: Record<string, unknown>;
  iconOnly?: boolean;
  title?: string;
  disabled?: boolean;
  disabledReason?: string;
}) {
  const { tenantId, isExporting, openExport } = useChemicalInventoryExport();
  const disabled = !tenantId || isExporting || disabledProp;

  const handleClick = () => openExport({ facilityId, facilityName, filter });

  if (!iconOnly) {
    const button = (
      <Button
        variant="text"
        size="medium"
        startIcon={<FileDownload />}
        onClick={handleClick}
        disabled={disabled}
        loading={isExporting}
      >
        {title}
      </Button>
    );
    if (!(disabled && disabledReason)) {
      return button;
    }
    return (
      <Tooltip title={disabledReason}>
        <span>{button}</span>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={title}>
      <IconButton
        size="medium"
        color="info"
        onClick={handleClick}
        disabled={disabled}
        loading={isExporting}
        aria-label={title}
      >
        <FileDownload />
      </IconButton>
    </Tooltip>
  );
}
